import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "Y0_EdFZTR4",
				"width": 523.6,
				"height": 80.56,
				"left": 205.46,
				"top": 216.66,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 61.22px;\"><span style=\"font-family: 方正正大黑简体;\"><span style=\"color: rgba(255,255,255,1);\">${title}</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "9xcWjZb4WC",
				"width": 0.06,
				"height": 0.06,
				"left": 445.28,
				"top": 126.41000000000001,
				"viewBox": [
					0.06,
					0.06
				],
				"path": "M 0.0075 0 L 0.0525 0 Q 0.06 0 0.06 0.0075 L 0.06 0.0525 Q 0.06 0.06 0.0525 0.06 L 0.0075 0.06 Q 0 0.06 0 0.0525 L 0 0.0075 Q 0 0 0.0075 0 Z",
				"fill": "#4f81bd",
				"fixedRatio": false,
				"rotate": 42,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "shape",
				"id": "-XmEWERVt9",
				"width": 0.06,
				"height": 0.06,
				"left": 445.28,
				"top": 126.39,
				"viewBox": [
					0.06,
					0.06
				],
				"path": "M 0.0075 0 L 0.0525 0 Q 0.06 0 0.06 0.0075 L 0.06 0.0525 Q 0.06 0.06 0.0525 0.06 L 0.0075 0.06 Q 0 0.06 0 0.0525 L 0 0.0075 Q 0 0 0.0075 0 Z",
				"fill": "#4f81bd",
				"fixedRatio": false,
				"rotate": 42,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "shape",
				"id": "laUZj29oXO",
				"width": 0.06,
				"height": 0.06,
				"left": 445.28,
				"top": 126.37,
				"viewBox": [
					0.06,
					0.06
				],
				"path": "M 0.0075 0 L 0.0525 0 Q 0.06 0 0.06 0.0075 L 0.06 0.0525 Q 0.06 0.06 0.0525 0.06 L 0.0075 0.06 Q 0 0.06 0 0.0525 L 0 0.0075 Q 0 0 0.0075 0 Z",
				"fill": "#4f81bd",
				"fixedRatio": false,
				"rotate": 42,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "text",
				"id": "qiN4Ix2AyJ",
				"width": 100.19,
				"height": 56.44,
				"left": 450.28,
				"top": 134.43,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"\"><span style=\"font-size: 40.82px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(246,232,232,1);\">${serial}</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	}
}